import React, { useState } from 'react';
import {
  View, Text, StyleSheet, FlatList,
} from 'react-native';
import Colors from '../../../../../../constants/Colors';
import PressableStyled from '../../../../../PressableStyled';
import Style from '../../../../../../constants/Style';
import { TemplateIssue } from '../../../../../../constants/Types';
import SolveLogo from '../../../../../SolveLogo';
import { getFormattedTemplateSubtitle, getFormattedTemplateTitle, openInNewTab } from '../../../../../../constants/Utils';
import DeleteIcon16 from '../../../../../16pxIcons/DeleteIcon16';

interface IssueListPreviewProps {
  templateTitle: string,
  templateSubtitle: string,
  templateSubtitleUrl: string,
  editTitle: () => void,
  issues: TemplateIssue[],
  hide?: () => void,
}

const IssueListPreview = ({
  templateTitle, templateSubtitle, issues, hide, templateSubtitleUrl,
}: IssueListPreviewProps) => {
  const [selectedItem, setSelectedItem] = useState<string>(null);

  const openSubtitleUrl: () => void = () => {
    openInNewTab(templateSubtitleUrl);
  };

  return <View
    testID='live-preview-modal'
    style={styles.wrapper}
  >
    <View style={styles.container}>
      <SolveLogo style={styles.header} />
      <View style={styles.content}>
        <Text style={styles.title}>
          {getFormattedTemplateTitle(templateTitle, 'this asset')}
        </Text>
        {/* <PressableStyled
            style={styles.editIcon}
            onPress={editTitle}
          >
            <EditIcon24 />
          </PressableStyled> */}
        {templateSubtitleUrl ? <PressableStyled onPress={openSubtitleUrl}>
          <Text style={[styles.subtitle, styles.underline]}>
            {getFormattedTemplateSubtitle(templateSubtitle)}
          </Text>
        </PressableStyled>
          : <Text style={styles.subtitle}>
            {getFormattedTemplateSubtitle(templateSubtitle)}
          </Text>}
        {/* <PressableStyled
            style={styles.editIcon}
            onPress={editTitle}
          >
            <EditIcon24 />
          </PressableStyled> */}
        <FlatList
          data={issues?.filter((issue: TemplateIssue) => issue.Text?.trim().length > 0
            && issue.Enabled) ?? []}
          renderItem={({ item }) => {
            const selected: boolean = [item.Id, item.LocalId, item.Text].includes(selectedItem);

            return <View style={styles.issueItem}>
              <PressableStyled
                onPress={() => {
                  setSelectedItem(selected ? null : item.Id ?? item.LocalId ?? item.Text);
                }}
              >
                <View style={[styles.issueItemRadioButton, selected && styles.radioButtonSelected]}>
                  {selected && <View style={styles.selectionIndicator} />}
                </View>
              </PressableStyled>
              <Text style={styles.issueItemText}>{item.Text}</Text>
            </View>;
          }}
          style={styles.issueList}
          keyExtractor={(_, index: number) => `template_preview_issue_${index}`}
        />
        <PressableStyled
          style={styles.button}
          disabled={!selectedItem}
        >
          <Text style={styles.buttonText}>{'Live Preview'}</Text>
        </PressableStyled>
      </View>
    </View>
    <PressableStyled
      style={Style.closeButton}
      onPress={hide}
      testID='close-live-preview-btn'
    >
      <DeleteIcon16 color={Colors.light.hereworksBlue500} />
    </PressableStyled>
  </View>;
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: '#FFF',
    height: '90%',
    aspectRatio: 0.6,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 40,
    paddingHorizontal: 80,
    borderRadius: 10,
  },
  container: {
    borderRadius: 16,
    backgroundColor: Colors.light.hereworksBlue500,
    height: 812,
    width: 375,
    alignSelf: 'center',
  },
  header: {
    marginTop: 44,
    marginBottom: 20,
    alignSelf: 'center',
  },
  content: {
    flex: 1,
    borderRadius: 16,
    backgroundColor: Colors.light.hereworksWhite200,
    padding: 24,
  },
  title: {
    fontSize: 22,
    lineHeight: 30,
    letterSpacing: 0,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
    textAlign: 'center',
    alignSelf: 'center',
  },
  subtitle: {
    fontSize: 14,
    lineHeight: 14,
    letterSpacing: 0,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlue400,
  },
  underline: {
    textDecorationLine: 'underline',
  },
  editIcon: {
    alignSelf: 'flex-start',
    marginStart: 8,
  },
  issueList: {
    flex: 1,
    marginTop: 24,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: Colors.light.hereworksBlue50,
  },
  issueItem: {
    ...Style.row,
    borderRadius: 16,
    backgroundColor: '#FFF',
    paddingVertical: 16,
    paddingHorizontal: 12,
    marginBottom: 12,
  },
  issueItemRadioButton: {
    width: 24,
    aspectRatio: 1,
    borderRadius: 100,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    marginEnd: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  radioButtonSelected: {
    borderColor: Colors.light.hereworksBlue500,
  },
  selectionIndicator: {
    width: 12,
    aspectRatio: 1,
    borderRadius: 100,
    backgroundColor: Colors.light.hereworksBlue500,
  },
  issueItemText: {
    flex: 1,
    fontSize: 16,
    lineHeight: 22,
    letterSpacing: 0,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
  },
  button: {
    borderRadius: 100,
    alignSelf: 'stretch',
    backgroundColor: Colors.light.hereworksLightBlue500,
    height: 52,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 24,
  },
  buttonText: {
    fontSize: 16,
    lineHeight: 16,
    letterSpacing: 0,
    fontFamily: 'Poppins_500Medium',
    color: '#FFF',
  },
});

export default IssueListPreview;
